import type { IRecord } from '@platform/core/types';

/** Вид запису бізнес-аналізу «наскрізний шлях користувача». */
export const JOURNEY_KIND = 'Customer journey';

/**
 * Номери наскрізних шляхів, що проходять через модуль (прототип v4 navPred «jr:»): запис виду «шлях», чий модуль — канонічна англійська
 * назва модуля (`enName`, як поле module записів аналізу), або чий опис згадує англійську чи українську назву (`ukName`) з урахуванням
 * регістру — «… → Завдання → …», але не «доручити завдання» чи «Підготовчі завдання». Порядок — як у вхідному списку. Чиста функція.
 */
export function journeyCodesOf(records: IRecord[], enName: string, ukName: string): number[] {
  const mentions = (text: string) => (!!enName && text.includes(enName)) || (!!ukName && text.includes(ukName));
  return records
    .filter((r) => r.values.kind === JOURNEY_KIND && ((!!enName && r.values.module === enName) || mentions(typeof r.values.description === 'string' ? r.values.description : '')))
    .map((r) => r.code);
}
